// extracted by mini-css-extract-plugin
export default {"auth":"AuthForm_auth__0mgDZ","control":"AuthForm_control__+fFHd","actions":"AuthForm_actions__eIaC5","toggle":"AuthForm_toggle__1s6Ce"};